import { InjectionToken } from "@angular/core";

import { GetIotnetGatewayHealth$Params, GetIotnetGatewayTraffic$Params } from "../../apis/stats/rest/functions";
import { HealthRecord, IotnetGateway, Traffic } from "../../apis/stats/rest/models";

export interface IotnetRepositoryPort {
  getIotnetGatewaysForCustomer(params: { customer_id: string }): Promise<IotnetGateway[]>;
  getIotnetGatewayHealth(params: GetIotnetGatewayHealth$Params): Promise<HealthRecord>;
  getIotnetGatewayTraffic(params: GetIotnetGatewayTraffic$Params): Promise<Traffic>;
}

export const IOTNET_REPOSITORY = new InjectionToken<IotnetRepositoryPort>("IotnetRepositoryPort");
